// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Service provider cell: one compact, never-wrapping action. */
.pac-row {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
}
.pac-names {
  line-height: 1.3;
}
.pac-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
}
.pac-btn-empty {
  padding: 6px 12px;
  color: #b45309;
  background: #fffbeb;
  border: 1px dashed #f59e0b;
}
.pac-btn-empty:hover,
.pac-btn-empty:focus-visible {
  color: #fff;
  background: #c0335a;
  border-color: #c0335a;
  border-style: solid;
}
.pac-btn-small {
  padding: 4px 10px;
  color: #c0335a;
  background: #fff;
  border: 1px solid #c0335a;
}
.pac-btn-small:hover,
.pac-btn-small:focus-visible {
  color: #fff;
  background: #c0335a;
}
.pac-open {
  color: #b45309;
}
.pac-none {
  color: #6b7280;
}
@media (pointer: coarse) {
  .pac-btn {
    min-height: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/providerAssignCell.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mEAAmE;AACrE;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Service provider cell: one compact, never-wrapping action. */\n.pac-row {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 8px;\n}\n.pac-names {\n  line-height: 1.3;\n}\n.pac-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background-color 0.15s, color 0.15s, border-color 0.15s;\n}\n.pac-btn-empty {\n  padding: 6px 12px;\n  color: #b45309;\n  background: #fffbeb;\n  border: 1px dashed #f59e0b;\n}\n.pac-btn-empty:hover,\n.pac-btn-empty:focus-visible {\n  color: #fff;\n  background: #c0335a;\n  border-color: #c0335a;\n  border-style: solid;\n}\n.pac-btn-small {\n  padding: 4px 10px;\n  color: #c0335a;\n  background: #fff;\n  border: 1px solid #c0335a;\n}\n.pac-btn-small:hover,\n.pac-btn-small:focus-visible {\n  color: #fff;\n  background: #c0335a;\n}\n.pac-open {\n  color: #b45309;\n}\n.pac-none {\n  color: #6b7280;\n}\n@media (pointer: coarse) {\n  .pac-btn {\n    min-height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
